import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/tracking';
import { captureAttribution } from '../lib/utm';
import Nav from './Nav';
import Footer from './Footer';
import CookieBanner from './CookieBanner';

export default function Layout({ children, hideFooter = false }) {
  const loc = useLocation();

  useEffect(() => {
    captureAttribution();
    trackPageview(loc.pathname + loc.search);
    window.scrollTo(0, 0);
  }, [loc.pathname, loc.search]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FAF8F5]">
      <Nav />
      <div className="h-16 lg:h-20" />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
      <CookieBanner />
    </div>
  );
}
